
import { BottomNav } from '../common/BottomNav.js';

export const AtaturkCornerScreen = () => `
    <div id="ataturk-corner-screen" class="screen">
        <div class="ataturk-hero">
            <img src="${new URL('../../assets/images/ataturk_kosesi/ataturk_main.jpg', import.meta.url).href}" alt="Atatürk" class="hero-img">
            <div class="hero-quote">
                "Türk milletinin karakteri yüksektir. Türk milleti çalışkandır. Türk milleti zekidir."
            </div>
        </div>

        <div class="ataturk-menu-container">
            <div class="ataturk-cards-grid">
                <div class="ataturk-card">
                    <img src="${new URL('../../assets/images/ataturk_kosesi/milli_mucadele.jpg', import.meta.url).href}" alt="Milli Mücadele">
                    <div style="flex: 1;">
                        <h4 style="margin-bottom: 5px;">MİLLİ MÜCADELE</h4>
                        <p style="font-size: 0.9rem; margin-bottom: 10px; text-align: left;">Kurtuluş Savaşı dönemi bilgini test et.</p>
                        <button class="action-btn orange-style" style="width: 150px; height: 40px; margin: 0;" onclick="window.startAtaturkTest('milli_mucadele')">BAŞLA ➤</button>
                    </div>
                </div>

                <div class="ataturk-card">
                    <img src="${new URL('../../assets/images/ataturk_kosesi/cagdas_turkiye.png', import.meta.url).href}" alt="Çağdaş Türkiye">
                    <div style="flex: 1;">
                        <h4 style="margin-bottom: 5px;">ÇAĞDAŞ TÜRKİYE</h4>
                        <p style="font-size: 0.9rem; margin-bottom: 10px; text-align: left;">Cumhuriyet devrimleri ve modernleşme süreci.</p>
                        <button class="action-btn orange-style" style="width: 150px; height: 40px; margin: 0;" onclick="window.startAtaturkTest('cagdas_turkiye')">BAŞLA ➤</button>
                    </div>
                </div>

                <div class="ataturk-card">
                    <img src="${new URL('../../assets/images/ataturk_kosesi/kim_taniyor.webp', import.meta.url).href}" alt="Atatürk'ü Kim Tanıyor">
                    <div style="flex: 1;">
                        <h4 style="margin-bottom: 5px;">ATATÜRK'Ü KİM TANIYOR?</h4>
                        <p style="font-size: 0.9rem; margin-bottom: 10px; text-align: left;">Ulu Önder hakkındaki detaylı bilgini ölç.</p>
                        <button class="action-btn orange-style" style="width: 150px; height: 40px; margin: 0;" onclick="window.startAtaturkTest('kim_taniyor')">BAŞLA ➤</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
`;

window.startAtaturkTest = async function (subType) {
    if (window.audio) window.audio.playSound('buttons');
    if (!window.TeableQuestionService || !window.game) {
        window.utils.showToast("Oyun servisleri başlatılamadı!", "error");
        return;
    }
    try {
        const questions = await window.TeableQuestionService.fetchAtaturkQuestions(subType);
        if (questions && questions.length > 0) {
            const niceNameMap = {
                'milli_mucadele': 'MİLLİ MÜCADELE',
                'cagdas_turkiye': 'ÇAĞDAŞ TÜRKİYE',
                'kim_taniyor': "ATATÜRK'Ü KİM TANIYOR?"
            };
            window.game.startCustomGame(questions, niceNameMap[subType] || 'ATATÜRK KÖŞESİ');
        } else {
            window.utils.showToast("Soru bulunamadı.", "warning");
        }
    } catch (e) {
        window.utils.showToast(`Hata: ${e.message}`, "error");
    }
};
